@if (hasData()) {
  <mat-table
    class="table-theme"
    [dataSource]="uploadData"
    >
    <!-- File Name -->
    <ng-container matColumnDef="fileName">
      <mat-header-cell *matHeaderCellDef>
        File Name
      </mat-header-cell>
      <mat-cell *matCellDef="let upload">
        {{ upload.filename }}
      </mat-cell>
    </ng-container>
    <!-- Copy Button -->
    <ng-container matColumnDef="copyUrl">
      <mat-header-cell *matHeaderCellDef>Copy Url</mat-header-cell>
      <mat-cell *matCellDef="let upload">
        <button
          mat-raised-button
          type="button"
          color="primary"
          (click)="copyToClipboard(upload.shortUrl)"
          matTooltip="Click to copy"
          matTooltipShowDelay="1000"
          >
          Copy File URL
        </button>
      </mat-cell>
    </ng-container>
    <!-- Delete Icon -->
    <ng-container matColumnDef="deleteIcon">
      <mat-header-cell *matHeaderCellDef>Delete</mat-header-cell>
      <mat-cell *matCellDef="let upload">
        <button
          mat-icon-button
          aria-label="Delete Upload button"
          type="button"
          [matMenuTriggerFor]="deleteConfirm"
          (click)="copyToClipboard(upload.shortUrl)"
          matTooltip="Delete"
          matTooltipShowDelay="1000"
          >
          <mat-icon class="icon" aria-label="Delete">delete</mat-icon>
        </button>
        <mat-menu #deleteConfirm="matMenu" xPosition="before">
          <p mat-menu-item class="margin-0" type="button" disabled>
            <span>Delete {{ upload.filename }}?</span>
          </p>
          <button
            mat-menu-item
            type="button"
            (click)="deleteFile(upload)"
            >
            <mat-icon color="primary">thumb_up</mat-icon>
            <span>Yes</span>
          </button>
          <button mat-menu-item type="button">
            <mat-icon color="warn">thumb_down</mat-icon>
            <span>No</span>
          </button>
        </mat-menu>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="assignment-upload-row"
      >
    </mat-row>
  </mat-table>
}

@if (!hasData()) {
  <no-assignment-uploads> </no-assignment-uploads>
}
